var _g;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconQuizLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconQuiz",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _g || (_g = /*#__PURE__*/React.createElement("g", {
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      d: "m746.255 1466.764 80.484 80.712-248.748 248.634-80.484-80.598 248.748-248.748Zm-165.904-165.836 80.598 80.598-331.626 331.626-80.598-80.598 331.626-331.626Zm-165.847-165.721 80.598 80.598-414.504 414.504L0 1549.71l414.504-414.504ZM1119.32 264.6c356.478-356.478 725.268-178.296 729.03-176.472l17.1 8.436 8.436 17.1c1.824 3.648 180.006 372.438-176.586 729.03l-146.604 146.604-2.622 665.874-222.642 222.642-331.626-331.512-578.094-578.094-331.626-331.74 222.642-222.642 665.874-2.508Zm316.92 839.154-361.836 361.95 251.028 250.914 108.87-108.87 1.938-503.994Zm343.026-921.348c-69.084-25.992-321.366-95.304-579.348 162.792l-623.01 623.01 416.898 416.898 622.896-623.01c256.956-256.956 187.986-511.176 162.564-579.69Zm-921.12 343.368-503.994 1.824-108.87 108.87L496.31 887.61l361.836-361.836Z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M1534.987 372.558c-51.072-1.368-131.67 12.768-213.294 94.392l-40.47 40.356 173.394 173.28 40.356-40.242c82.194-82.308 96.9-161.31 94.848-213.18l-2.166-52.554-52.668-2.052Z"
    }))));
  }
}
IconQuizLine.glyphName = 'quiz';
IconQuizLine.variant = 'Line';
IconQuizLine.displayName = 'IconQuizLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconQuizLine.propTypes = {
  ...SVGIcon.propTypes
};
IconQuizLine.allowedProps = [...SVGIcon.allowedProps];
export default IconQuizLine;
export { IconQuizLine };